/**
 * What the auth bootstrap should do next, split out of
 * `entity-scope-resolution.ts` (DV-3013 PR 4, spec §4's decomposition item).
 *
 * A leaf module with no imports, so `entity-scope-denial.ts` can return the
 * type without importing the module that imports IT — a cycle TypeScript would
 * erase, but which this repo has already paid for once (spec §2.4).
 */

/**
 * What the auth bootstrap should do next (spec §3.2 / D15).
 *
 * A discriminated union, not a widened string: both callers branch on it, and
 * collapsing four "a navigation is underway" reasons into one token would
 * repeat exactly the defect `orgCheck`'s boolean had.
 */
export type ScopeOutcome =
  /** Correctly scoped (or the route does not care). Render. */
  | { kind: 'ready' }
  /** Switched in place via `'stay'`. Render — now correctly scoped. */
  | { kind: 'switching' }
  /** A full-page trip has started. Hold a spinner until the tab swaps. */
  | { kind: 'navigating' }
  /** DV-3175: authenticated, fully registered, member of no organization. */
  | { kind: 'no-organizations' }
  /** Render the error screen. `entity-access` = no access; `unknown` = broke. */
  | { kind: 'denied'; reason: 'entity-access' | 'unknown' };

export const READY: ScopeOutcome = { kind: 'ready' };
